import { memo } from 'react';
import { Group } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { FilterPill } from './FilterPill';

export interface PillData {
  readonly id: string;
  readonly label: string;
  readonly value: string;
  readonly onRemove: () => void;
}

interface FilterPillsListProps {
  readonly pills: readonly PillData[];
}

export const FilterPillsList = memo(function FilterPillsList({
  pills,
}: FilterPillsListProps) {
  const { t } = useTranslation();

  if (pills.length === 0) return null;

  return (
    <Group gap="xs" wrap="wrap">
      {pills.map((pill) => (
        <FilterPill
          key={pill.id}
          label={pill.label}
          value={pill.value}
          onRemove={pill.onRemove}
          ariaLabel={t('filters.clearFilter')}
        />
      ))}
    </Group>
  );
});
